import { useEffect, useState } from 'react';
import AnomaliesServices from '../../services/anomaliesServices';
import { message, Table, Button, Card, Space, Typography, Popconfirm, Col, Row, Divider, Collapse, Input } from 'antd';
import { notifyMessages, tablePageSize } from '../../utils/constants';
import { PageHeader } from '../../components/common/pageHeader';
import NewAnomalie from './newAnomalie';
import { DeleteFilled, PlusOutlined, WarningOutlined } from '@ant-design/icons';
import UpdateAnomalie from './updateAnomalie';
import "./anomalies.scss";
import { useCurrentUserContext } from '../../context/currentUserContext';
import { isSuperAdmin } from '../../configs/auth/roleRights';

const { Link } = Typography;

const initialFilters = {
    anomalyName: "",
    isEnabled: true
};

const AnomaliesList = () => {

    const [filters, setFilters] = useState(initialFilters);
    const [anomalies, setAnomalies] = useState([]);
    const [loadingData, setLoadingData] = useState([]);
    const [openCreateDrawer, setOpenCreateDrawer] = useState(false);
    const [openUpdateDrawer, setOpenUpdateDrawer] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const { currentUser } = useCurrentUserContext();

    useEffect(() => {
        getAnomalies(initialFilters);
    }, []);

    const getAnomalies = async (appliedFilters) => {
        setLoadingData(true);
        try {
            const respData = await AnomaliesServices.getAnomalies(appliedFilters, currentUser.lastSelectedCategory);
            if (respData.success) {
                const res = respData.responseObject.value.anomaliesListDTO;
                setAnomalies(res);
                setLoadingData(false);
            }
            else {
                message.error(notifyMessages.errorAccured);
                setLoadingData(false);
            }
        } catch (error) {
            console.error('Failed:', error.message);
            setLoadingData(false);
        }
    };

    const showDrawer = (drawerName, record) => {
        if (drawerName === "create") setOpenCreateDrawer(true);
        if (drawerName === "update") setOpenUpdateDrawer(true); setSelectedRecord(record);
    }

    const onCloseDrawer = (drawerName) => {
        if (drawerName === "create") setOpenCreateDrawer(false);
        if (drawerName === "update") setOpenUpdateDrawer(false);
    };

    const onRemoveAnomalie = async (anomalieId) => {
        try {
            const respData = await AnomaliesServices.deleteAnomalie(anomalieId);

            if (respData.success) {
                message.success(notifyMessages.operationSuccess);
                getAnomalies(filters);
            }
            else {
                message.error(notifyMessages.errorAccured);
            }

        } catch (error) {
            message.error(notifyMessages.errorAccured);
        }
    };

    const columns = [
        {
            title: 'Anomalia',
            dataIndex: 'name',
            key: 'name',
        },
        {
            key: "action1",
            width: "50px",
            render: (_, record) => {
                return (
                    <Space>
                        <Link style={{ color: "#0f4d65" }} onClick={() => showDrawer("update", record)}>Apri</Link >
                    </Space>
                )
            }
        },
        {
            key: "action2",
            width: "30px",
            render: (_, record) => {
                return (
                    <>
                        {isSuperAdmin(currentUser) && (
                            <Popconfirm
                                placement="topRight"
                                key="remove"
                                title="Vuoi eliminare questo anomalia?"
                                icon={<WarningOutlined style={{ color: '#f7c924' }} />}
                                okText="Si"
                                cancelText="No"
                                onConfirm={() => onRemoveAnomalie(record.id)}
                            >
                                <DeleteFilled style={{ color: '#023B72' }} title={"Elimina Anomalia"} />
                            </Popconfirm>
                        )}
                    </>
                )
            }
        }
    ];

    const onFilter = () => {
        getAnomalies(filters);
    }

    const onClearFilters = () => {
        setFilters(initialFilters);
        getAnomalies(initialFilters);
    }

    const handelFilterChange = (name, value) => {
        setFilters((prev) => ({ ...prev, [name]: value }));
    }

    const panelItems = [
        {
            key: '1',
            label: 'Filtra',
            children: (
                <>
                    <Row gutter={{ lg: 24 }}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 6 }} lg={{ span: 6 }}>
                            <Space direction='vertical'>
                                <span>Nome</span>
                                <Input value={filters.anomalyName} onChange={(e) => handelFilterChange("anomalyName", e.target.value)} />
                            </Space>
                        </Col>
                    </Row>
                    <Divider />
                    <Row gutter={{ lg: 24 }}>
                        <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                            <Button type="primary" style={{ marginRight: 10 }} onClick={() => onFilter()}> Filtra </Button>
                            <Button onClick={() => onClearFilters()}> Rimuovi  </Button>
                        </Col>
                    </Row>
                </>
            )
        }
    ]

    return (
        <div className='anomaliesContainer'>
            <NewAnomalie open={openCreateDrawer} onClose={() => onCloseDrawer("create")} getAnomalies={() => getAnomalies(initialFilters)} />

            {selectedRecord && (
                <UpdateAnomalie open={openUpdateDrawer} onClose={() => onCloseDrawer("update")} getAnomalies={() => getAnomalies(initialFilters)} recordData={selectedRecord} />
            )}

            <PageHeader title="Anomalie" />

            <Row gutter={{ lg: 24 }} className="usersContainer filters-collapse" >
                <Col className="gutter-row" xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                    <Collapse size='small' className='filterPanel' items={panelItems} defaultActiveKey={['1']} />
                </Col>
            </Row>

            <Card extra={<Button type="primary" onClick={() => showDrawer("create")} icon={<PlusOutlined />}>Aggiungi</Button>}>
                <Table
                    className='customTableRows'
                    rowClassName={(_, index) =>
                        index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                    }
                    dataSource={anomalies}
                    columns={columns}
                    rowKey={obj => obj.id}
                    pagination={{
                        pageSize: tablePageSize
                    }}
                    loading={loadingData}
                    size='small'
                    bordered
                />
            </Card>
        </div>
    )
}
export default AnomaliesList;